{
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "retry": "Réessayer",
    "loadMore": "Charger plus",
    "clearFilters": "Effacer les filtres",
    "close": "Fermer",
    "search": "Rechercher",
    "refresh": "Actualiser",
    "edit": "Modifier",
    "copy": "Copier",
    "copied": "Copié"
  },
  "theme": {
    "label": "Thème",
    "light": "Clair",
    "dark": "Sombre",
    "system": "Système"
  },
  "operators": {
    "bank": "Virement bancaire"
  },
  "language": {
    "label": "Langue",
    "en": "Anglais",
    "fr": "Français",
    "endonym": {
      "fr": "Français",
      "en": "English"
    },
    "switchTo": "Afficher cette page en anglais"
  },
  "permissionDenied": {
    "title": "Vous n’avez pas accès à cette page",
    "body": "Demandez à un administrateur de vous accorder la permission ci-dessous si vous en avez besoin."
  },
  "states": {
    "loading": "Chargement",
    "emptyTitle": "Rien pour le moment",
    "filteredEmptyTitle": "Aucun résultat pour ces filtres",
    "filteredEmptyBody": "Essayez de retirer un filtre pour élargir la recherche.",
    "errorTitle": "Une erreur est survenue",
    "offlineTitle": "Vous semblez hors ligne",
    "offlineBody": "Vérifiez votre connexion puis réessayez.",
    "serverErrorBody": "L’erreur vient de nous, pas de vous. Réessayer suffit souvent.",
    "requestId": "Référence",
    "yes": "Oui",
    "no": "Non"
  },
  "notFound": {
    "title": "Page introuvable",
    "body": "La page demandée n’existe pas, ou vous n’y avez plus accès."
  },
  "totp": {
    "qrAlt": "Code QR pour la configuration de l’authentification à deux facteurs",
    "manualEntry": "Ou saisissez ce code manuellement :",
    "code": "Code d’authentification",
    "submit": "Vérifier et continuer",
    "wrongCode": "Ce code n’a pas été accepté. Vérifiez l’heure de votre appareil et réessayez.",
    "recoveryWarning": "Ces codes ne sont affichés qu’une seule fois et ne sont conservés nulle part où vous pourriez les récupérer. Enregistrez-les en lieu sûr avant de continuer.",
    "recoveryAck": "J’ai enregistré ces codes",
    "recoveryCodes": "Codes de récupération",
    "recoveryDownload": "Télécharger (.txt)",
    "copyFailed": "Le navigateur a refusé la copie. Téléchargez plutôt les codes."
  },
  "responsive": {
    "title": "Idéal sur un plus grand écran",
    "body": "Cet écran est conçu pour un affichage plus grand. Utilisez une tablette ou un ordinateur, ou retournez à la Vue d’ensemble pour ce qui est disponible sur téléphone.",
    "backToOverview": "Retour à la Vue d’ensemble"
  },
  "segments": {
    "summary_one": "{{length}} caractères · {{count}} segment ({{encoding}})",
    "summary_other": "{{length}} caractères · {{count}} segments ({{encoding}})"
  },
  "phone": {
    "placeholder": "6XX XXX XXX"
  },
  "proof": {
    "chooseFile": "Choisir un fichier",
    "hint": "PDF, PNG ou JPEG, jusqu’à 5 Mo",
    "errorType": "Choisissez un fichier PDF, PNG ou JPEG.",
    "errorSize": "Ce fichier dépasse 5 Mo.",
    "uploading": "Envoi de la preuve"
  },
  "progress": {
    "unlimited": "Illimité"
  },
  "onlineDot": {
    "online": "En ligne",
    "offline": "Hors ligne"
  },
  "idle": {
    "title": "Vous allez bientôt être déconnecté",
    "body": "Aucune activité depuis 25 minutes. Pour protéger votre compte, vous serez déconnecté dans 5 minutes.",
    "stay": "Rester connecté",
    "signOut": "Se déconnecter"
  },
  "stepUp": {
    "title": "Confirmez votre identité",
    "body": "Cette action demande à nouveau votre mot de passe.",
    "bodyTotp": "Cette action demande votre mot de passe et un code de votre application d’authentification.",
    "password": "Mot de passe",
    "code": "Code de vérification",
    "recoveryCode": "Code de récupération",
    "useRecovery": "Utiliser plutôt un code de récupération",
    "useApp": "Utiliser plutôt un code de l’application",
    "confirm": "Confirmer",
    "confirming": "Vérification…",
    "cancel": "Annuler"
  },
  "range": {
    "label": "Période",
    "7d": "7 jours",
    "30d": "30 jours",
    "90d": "90 jours",
    "custom": "Personnalisée",
    "from": "Du",
    "to": "Au",
    "apply": "Appliquer",
    "order": "Choisissez un premier jour antérieur ou égal au dernier.",
    "tooLong": "Une période couvre au plus {{days}} jours.",
    "dialog": "Période personnalisée"
  },
  "summary": {
    "noComparison": "Pas de comparaison",
    "points": "{{value}} pts"
  },
  "authShowcase": {
    "eyebrow": "Passerelle SMS",
    "headline": "Faites de vos téléphones Android une passerelle SMS.",
    "lead": "Envoyez et recevez des SMS depuis vos propres cartes SIM via une API simple, et suivez l’arrivée de chaque message.",
    "features": {
      "sims": {
        "title": "Vos SIM, vos numéros",
        "body": "Les messages partent des téléphones que vous connectez."
      },
      "api": {
        "title": "API REST et webhooks",
        "body": "Intégrez en quelques minutes ; chaque réponse vous parvient en temps réel."
      },
      "delivery": {
        "title": "Une livraison visible",
        "body": "Chaque message suivi, de l’envoi à la réception."
      }
    },
    "delivered": "Délivré"
  },
  "hiis": {
    "label": "HIIS, la société derrière DevSMS",
    "byline": "DevSMS by HIIS"
  },
  "footer": {
    "label": "Liens utiles",
    "download": "Télécharger l’app Android",
    "status": "État du service",
    "support": "Support",
    "apiGuide": "Guide de l’API",
    "privacy": "Confidentialité",
    "refundPolicy": "Remboursements"
  }
}
